import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoanRepaymentFormPage from "./LoanRepaymentFormPage";
import LoanRepaymentListPage from "./LoanRepaymentListPage";
import { LoanRepaymentProvider } from "../../store/loanRepaymentContext";
import { CustomerProvider } from "../../store/customerContext";
import { CurrencyProvider } from "../../store/currencyContext";

const LoanRepaymentIndex: React.FC = () => (
    <CustomerProvider>
        <CurrencyProvider>
            <LoanRepaymentProvider>
                <Routes>
                    <Route path="form" element={<LoanRepaymentFormPage />} />
                    <Route path="form/:id" element={<LoanRepaymentFormPage />} />
                    <Route path="list" element={<LoanRepaymentListPage />} />
                    <Route index element={<Navigate to="list" replace />} />
                    <Route path="*" element={<Navigate to="list" />} />
                </Routes>
            </LoanRepaymentProvider>
        </CurrencyProvider>
    </CustomerProvider>
);

export default LoanRepaymentIndex;
